<template>
    <v-flex
            v-bind:class="{ xs6: !mobile, xs12: mobile }" class="sm6, md3"
    >
        <v-card
            hover
            height="100%"
            @click.self="goTo('/bot' + bot.id + '/message')"
        >
            <v-card-title
                @click="goTo('/bot' + bot.id + '/message')"
                class="py-3"
            >
                <v-row>
                    <v-col cols="12" class="pa-0 px-4">
                                    <span class="body-1 font-weight-light text-truncate"
                                          :title="bot.title"
                                    >{{ bot.title | truncate(18, '...') }}</span>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text
                @click.self="goTo('/bot' + bot.id + '/message')"
            >
                <v-row>
                    <v-col cols="6" class="pa-0 px-4" @click="goTo('/bot' + bot.id + '/message')">
                                    <span v-show="bot.token_vk != 0" title="Токен Вконтакте для сообщений подключен">
                                        <font-awesome-icon :icon="['fab', 'vk']" size="2x"
                                                           :style="{ color: '5e94e5' }"/>
                                    </span>
                        <span v-show="bot.token_vk != 0">&#160;</span>
                        <span v-show="bot.token_vk_mailing != 0"
                              title="Токен Вконтакте для рассылок подключен">
                                        <font-awesome-icon :icon="['fab', 'vk']" size="2x"
                                                           :style="{ color: '5e94e5' }"/>
                                    </span>
                        <span v-show="bot.token_vk != 0">&#160;</span>
                        <span v-show="bot.token_tg != 0" title="Токен Telegram подключен">
                                        <font-awesome-icon :icon="['fab', 'telegram-plane']" size="2x"
                                                           :style="{ color: '5e94e5' }"/>
                            <!--<img alt="123" src="../assets/icons/vk-social-network-logo.svg" size="12px" style="fill: green; width: 32px">-->
                                    </span>
                    </v-col>
                    <v-spacer @click="goTo('/bot' + bot.id + '/message')"></v-spacer>
                    <v-menu bottom left>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                light
                                icon
                                v-on="on"
                            >
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                @click="removeBot(parentIndex)"
                            >
                                <v-list-item-title>Удалить</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                @click="editBot(parentIndex)"
                            >
                                <v-list-item-title>Настройки</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>
export default {
    name: 'BotCard',
    props: {
        bot: Object,
        parentIndex: Number,
        mobile: Boolean
    },
    methods: {
        goTo(url) {
            this.$router.push({ path: url })
        },
        removeBot(index) {
            this.$emit('removeBot', index)
        },
        editBot(index) {
            this.$emit('editBot', index)
        }
    },
    filters: {
        truncate(text, length, suffix) { /// *.title | truncate(18, '...')*/
            if (text.length > length) {
                return text.substring(0, length) + suffix
            } else {
                return text
            }
        }
    }

}
</script>

<style scoped>

</style>
